// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-search-input {
    width: 100%;
    padding: 0.2vw 0;
    background-color: transparent;
    border: none;
    border-bottom: 0.1vw solid #333;
    color: #fff;
    font-size: 0.9vw;
    font-family: 'Poppins', sans-serif;
    outline: none;
    transition: border-color 0.3s ease;
  }
 
  .custom-search-input::placeholder {
    color: #777;
    font-weight: 300;
    text-align: center;
  }
 
  .custom-search-input:focus {
    border-bottom: 0.1vw solid #50C878;
  }
`, "",{"version":3,"sources":["webpack://./src/components/ui/cartSection/cartSection.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,+BAA+B;IAC/B,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;EACpC","sourcesContent":[".custom-search-input {\n    width: 100%;\n    padding: 0.2vw 0;\n    background-color: transparent;\n    border: none;\n    border-bottom: 0.1vw solid #333;\n    color: #fff;\n    font-size: 0.9vw;\n    font-family: 'Poppins', sans-serif;\n    outline: none;\n    transition: border-color 0.3s ease;\n  }\n \n  .custom-search-input::placeholder {\n    color: #777;\n    font-weight: 300;\n    text-align: center;\n  }\n \n  .custom-search-input:focus {\n    border-bottom: 0.1vw solid #50C878;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
